<template>
  <div v-loading.fullscreen="loading" element-loading-text="Saving Data ..." element-loading-spinner="el-icon-loading">
    <nav-basic :progress="10" title="Start with the basics" :btn="false"></nav-basic>
    <div class="container">
      <b-row class="step-header">
        <h2>Where's your place located?</h2>
      </b-row>
      <b-row>
        <b-col md="5" class="pt-2">
          <b-form @submit="navigate">
            <b-row>
              <b-col class="text-right pr-0">
                <b-form-group vertical breakpoint="lg" label="Country" label-for="inputHorizontal" align="left">
                  <b-form-select v-model="dt.address.country" required>
                      <option value="estonia">Estonia</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-right pr-0">
                <b-form-group id="fieldsetHorizontal" vertical breakpoint="lg" label="County" label-for="inputHorizontal" align="left">
                  <b-form-select :disable="dt.address.country!='estonia'" name="county" v-validate="'alpha_spaces'" v-model="dt.address.county" placeholder="County" required :options="estCountyList">
                  </b-form-select>
                  <!-- <b-form-input id="inputHorizontal" v-validate="'alpha_spaces'" name="county" v-model="dt.address.county" placeholder="County"
                    required :state="errors.has('county')?false:null"></b-form-input>
                  <span v-show="errors.has('county')" class="help is-danger">{{ errors.first('county') }}</span> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-right pr-0">
                <b-form-group id="fieldsetHorizontal" vertical breakpoint="lg" label="Municipality" label-for="inputHorizontal" align="left">
                  <b-form-input id="inputHorizontal" v-validate="'alpha_spaces'" name="municipality" v-model="dt.address.municipality" placeholder="City/Parish"
                    required :state="errors.has('municipality')?false:null"></b-form-input>
                  <span v-show="errors.has('municipality')" class="help is-danger">{{ errors.first('municipality') }}</span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-right pr-0">
                <b-form-group id="fieldsetHorizontal" vertical breakpoint="lg" label="Street Name" label-for="inputHorizontal" align="left">
                  <b-form-input id="inputHorizontal" name="street" v-model="dt.address.street" placeholder="Street name" required></b-form-input>
                  <!-- <span v-show="errors.has('street')" class="help is-danger">{{ errors.first('street') }}</span>                 -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-right pr-0">
                <b-form-group id="fieldsetHorizontal" vertical breakpoint="lg" label="Building Number" label-for="inputHorizontal" align="left">
                  <b-form-input id="inputHorizontal" v-model="dt.address.number" placeholder="Building number" required></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-right pr-0">
                <b-form-group id="fieldsetHorizontal" vertical breakpoint="lg" label="Apartment Number (Optional)" label-for="inputHorizontal"
                  align="left">
                  <b-form-input id="inputHorizontal" v-model="dt.address.apartNumber" placeholder="Apartment Number"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- <b-row>
              <b-col class="text-right pr-0">
                <b-form-group id="fieldsetHorizontal" vertical breakpoint="lg" label="Location Preview" label-for="inputHorizontal"
                  align="left">
                  <gmap-map ref="mymap" :center="mapStartLocation" :zoom="17" style="width: 100%; height: 300px">
                    <gmap-marker v-if="loadingAddress" :position="mapStartLocation" :draggable="false"/>
                  </gmap-map>
                </b-form-group>
              </b-col>
            </b-row> -->

            <b-row class="step-navigator-buttons">
              <b-col style="text-align:left;padding:0">
                <b-button @click="prev"  variant="outline-primary" class="btn-step-navigator">Back</b-button>
              </b-col>
              <!-- <b-col style="text-align:center;padding:0">
                <b-button @click="save" variant="outline-primary">Save and Exit</b-button>
              </b-col> -->
              <b-col style="text-align:right;padding:0">
                <b-button type="submit" variant="primary" class="btn-step-navigator">Next</b-button>
              </b-col>
              <!-- <b-col style="text-align:right;padding:0">
                <b-button @click="test" variant="primary">test</b-button>
              </b-col> -->
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </div>

</template>

<script>
  import {
    Validator
  } from 'vee-validate'

  // import {
  //   countryList,
  //   countyList
  // } from '../lists.js'
  const lists = require("@/lists.js");

  import {
    getUserUid,
    pullAvailableLocAndBuildDataToSS
  } from '../functions.js'
  let props
  export default {
    name: 'basic1',
    validator: null,
    data() {
      return {
        loading: false,
        options: lists.countryList,
        estCountyList: lists.countyList,
        test: ''
      }
    },
    created() {
    },
    computed: {
      dt() {
        // only for debug
        var locationFromStore = this.$store.getters.location
        locationFromStore.address.country = "estonia"
        return locationFromStore
      }
    },
    methods: {
      leavePage(from, to){
        this.$store.dispatch('visitPage', from);
        this.$router.push({
          name: to
        })
      },
      prev() {
        this.leavePage('BASIC1', 'adr')
      },
      navigate(evt) {
        evt.preventDefault();
        let locationRequest = this.getLocationRequest()
        pullAvailableLocAndBuildDataToSS(locationRequest)
        this.saveAddressPartsToSessionStorage(locationRequest.address)
        this.$store.commit('UPDATE_LOCATION', locationRequest.address)
        this.leavePage('BASIC1', 'basic2')
      },
      getMuniWithoutExtras(municipality){
        let muni = municipality
        try{
          let indexOfVald = municipality.toLowerCase().indexOf('vald')
          if(indexOfVald !== -1) muni = muni.substring(-1, indexOfVald).trim();
          return muni
        }catch(err){}
        return municipality
      },
      getLocationRequest(){
        let muni = this.getMuniWithoutExtras(this.dt.address.municipality)
        return {
          address:{
            country: this.dt.address.country,
            county:  this.dt.address.county,
            municipality: muni,
            street: this.dt.address.street,
            number: this.dt.address.number,
            apartNumber: this.dt.address.apartNumber
          }
        }
      },
      saveAddressPartsToSessionStorage(address){
        sessionStorage.setItem('country', address.country)
        sessionStorage.setItem('county', address.county)
        sessionStorage.setItem('municipality', address.municipality)
        sessionStorage.setItem('street',address.street)
        sessionStorage.setItem('number',address.number)
        sessionStorage.setItem('apartNumber',address.apartNumber)
      }
    }
  }

</script>

<style scoped>
  @import '../assets/styles/add-steps.css';
  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/basic1.vue